import type { BackgroundJobSnapshot } from "../model/block.types";

/** Only these three run statuses stop the polling Observable. */
export function isTerminalStatus(status: string | null): boolean {
  return status === "success" || status === "error" || status === "timeout";
}

/** Maps raw run status string to the typed union (null for unknown/unmapped values). */
export function mapRunStatus(raw: string): BackgroundJobSnapshot["run_status"] {
  switch (raw) {
    case "pending":
    case "running":
    case "interrupted":
    case "success":
    case "error":
    case "timeout":
      return raw;
    default:
      return null;
  }
}
